import React, { useRef } from 'react';
import type { FC } from 'react';
import { Box, Typography } from '@mui/material';
import useVendor from '../../../hooks/useVendor';
import { useNavigate } from 'react-router-dom';
import BasePrimaryNavItem from './BasePrimaryNavItem';
import CloseIcon from '@mui/icons-material/Close';
import { isVendor, Vendor } from 'src/types/vendor';
import VendorDropdown from 'src/components/controls/VendorDropdown';
import useVendorBooth from 'src/hooks/useVendorBooth';
import UserDropdown from 'src/components/controls/UserDropdown';
import { isVendorUser, VendorUser } from 'src/types/vendorUser';
import VendorApi from 'src/api/VendorApi';
import useAuth from 'src/hooks/useAuth';
declare interface Props {
  isPopover?: boolean;
  onCloseNav?: () => void;
}

const VendorItem: FC<React.PropsWithChildren<Props>> = (props) => {
  const { vendor, saveVendor } = useVendor();
  const { resetBoothToDefault } = useVendorBooth();
  const navigate = useNavigate();
  const menuRef = useRef<any>(null);
  const { hasImpersonateVendorAuth } = useAuth();

  const menu = {
    section: 'Vendor',
    items: [
      {
        title: 'Dashboard',
        path: '/',
      },
    ],
  };

  const onChange = (value: NonNullable<string | Vendor>) => {
    if (isVendor(value) && vendor.number !== value.number) {
      menuRef?.current.closeMenu();
      resetBoothToDefault();
      saveVendor(value);
      navigate(`/${value.number}`);
    }
  };

  const onUserChange = (value: NonNullable<string | VendorUser>) => {
    console.log('onUserChange', value);
    if (isVendorUser(value)) {
      menuRef?.current.closeMenu();
      resetBoothToDefault();
      VendorApi.getVendorByNumber(value.vendorNumber).then((vendorData) => {
        saveVendor(vendorData.value[0]);
        navigate(`/${value.vendorNumber}`);
      });
    }
  };

  const content = (
    <div onKeyDown={(e) => e.stopPropagation()}>
      <p className="global-nav__section-title">{menu.section}</p>{' '}
      <div onClick={props.onCloseNav} className="global-nav__close-icon">
        <CloseIcon />
      </div>
      <div className="global-nav__item__vendorsearch">
        {vendor.number && (
          <Box>
            <Typography color="textSecondary" variant="subtitle2">
              {` ${vendor.name} (${vendor.number})`}
            </Typography>
          </Box>
        )}
        <Box>
          <VendorDropdown onChange={onChange} />
          {hasImpersonateVendorAuth() && <UserDropdown onChange={onUserChange} />}
        </Box>
      </div>
      {/* <Divider className="d-none d-md-block" />
      <div className="global-nav__item">
        {menu.items.map((item, index) => {
          return (
            <div className="global-nav__item-link" key={index}>
              <RouterLink to={item.path} key={index}>
                {item.title}
              </RouterLink>
            </div>
          );
        })}
      </div> */}
    </div>
  );

  return (
    // <BasePrimaryNavItem anchorEl={vendor.name ? menu.section + vendor.name : menu.section} isPopover={props.isPopover}>
    <BasePrimaryNavItem
      id="vendorMenuButton"
      title={`Vendor# : ${vendor.number}`}
      anchorEl={vendor.name ? <div className="global-header__vendor--active">{vendor.name}</div> : menu.section}
      isPopover={props.isPopover}
      ref={menuRef}
    >
      <div className="global-nav__vendor">{content}</div>
    </BasePrimaryNavItem>
  );
};

export default VendorItem;
